/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './CustomVideoPage.scss';

// import('./SundaySky').then((ss) => ss.loadSundaySky());
import { toUpper, isNil } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { getBaseUrl, deriveEnvironment } from 'services/globals';
import {
  getCustomVideoState,
  getCustomVideoEligibility,
  getHasCustomVideo
} from 'state/customVideo/CustomVideoSelectors';
import { getCustomer } from 'state/customer/CustomerSelectors';
import { getQueryParams } from 'state/session/SessionSelectors';
import CustomVideo from 'components/shared/CustomVideo/CustomVideo';
import { getCustomVideo } from 'services/Rest';
import {
  getEligibleBeneficiaries,
  placeholderImages
} from 'services/CustomVideo';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import { getSearchParams } from 'services/globals';
import {
  transactions,
  maryland529Calculator,
  national529Calculator
} from 'services/Externals';
import dollarSign from 'assets/custom-video/cta_dollarsign.png';
import planner from 'assets/custom-video/cta_planner.png';
import { getProvidedProductType, MARYLAND_529_CLASS } from 'services/Products';
import AAMFooterContainer from '../../layouts/Footer/FooterUtil';
import { mapProductTypeToiiFooterBoolean } from 'state/account/AccountSelectors';
import { getView, isMobile } from 'state/view/ViewSelectors';

class CustomVideoPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEligible: true,
      isLoading: true,
      isError: false,
      params: {}
    };
  }

  componentDidMount() {
    const {
      location: { search }
    } = this.props;

    const loadVideoEvent = new Event('load-ssky-video');
    // Dispatch ssky event
    window.dispatchEvent(loadVideoEvent);

    const params = getSearchParams(search);
    this.setState({ params });

    const providedProductType = getProvidedProductType(params.productType);
    const providedTouchPoint = params.touchPoint ? params.touchPoint : '';
    getCustomVideo(providedProductType, providedTouchPoint, '');
  }

  componentWillUnmount() {
    const removeVideoEvent = new Event('remove-ssky-video');
    // Dispatch ssky event
    window.dispatchEvent(removeVideoEvent);
  }

  componentDidUpdate(prevProps) {
    const {
      requestStatus,
      customVideo: { externalUberId }
    } = this.props;

    const customVideoReceived =
      requestStatus.customVideo === REQUEST_STATES.received &&
      prevProps.requestStatus.customVideo !== REQUEST_STATES.received;
    if (
      prevProps.requestStatus.customVideo === REQUEST_STATES.requested &&
      requestStatus.customVideo === REQUEST_STATES.error
    ) {
      this.setState({ isError: true, isLoading: false });
    }
    if (customVideoReceived) {
      this.setState({ isLoading: false });

      window.sskSegments = {
        userid: externalUberId,
        page: document.title,
        source: '', // Values could be "email", "sms", "portal", "mobile app". Leave blank if page is reached organically
        env: deriveEnvironment(getBaseUrl())
      };
    }
  }

  handleButtonClick = (event, bene) => {
    const {
      params: { touchPoint = '', productType = MARYLAND_529_CLASS }
    } = this.state;
    const { uberId = '' } = bene;
    getCustomVideo(getProvidedProductType(productType), touchPoint, uberId);
    this.setState({ isLoading: true });
  };

  render() {
    const {
      customVideo: { base64RequestString: videoUrl, activeBeneficiary },
      isMobileApp,
      footerProductTypes,
      videoEligibilities,
      customVideoEligibility,
      requestStatus,
      view
    } = this.props;
    const {
      isLoading,
      isError,
      params: { productType = MARYLAND_529_CLASS }
    } = this.state;
    const VIDEO_URL = videoUrl || '';

    const providedProductType = getProvidedProductType(productType);

    //Get array of eligible beneficiary keys based on product type
    const eligibleBeneficiaries = getEligibleBeneficiaries(
      providedProductType,
      videoEligibilities,
      activeBeneficiary
    );
    const eligibilitiesReceived =
      requestStatus.videoeligibilities === REQUEST_STATES.received;
    const isEligible = customVideoEligibility[providedProductType];

    if (isLoading) {
      return (
        <div className="center">
          <PageLoadingSpinner name="Your Custom Video" />
        </div>
      );
    }

    if (view && view.hasNoAccounts) {
      return <Redirect to="/no-accounts" />;
    }

    if (isError || (!isEligible && eligibilitiesReceived) || isNil(videoUrl)) {
      return (
        <div className="custom-video-page-container">
          <div className="custom-video-layout-container">
            <div className={`${providedProductType}-custom-video-header`}>
              <span className="header-title">Your Custom Video</span>
            </div>
            <div className="title-text-container">
              <div className={`${providedProductType}-title-text`}>
                Thank You For Your Interest
              </div>
              <div className="active-beneficiary-text">
                We do not have a video available for you at this time. You can
                still:
              </div>
            </div>
            <div className="custom-video-ineligible-buttons-container">
              <div
                className={`${providedProductType}-ineligible-button-background`}>
                <a
                  href={
                    transactions.collegeSavings.automaticMonthlyContributions
                  }
                  className="ineligible-button">
                  <img
                    alt="custom-icon"
                    className="custom-video-button-image"
                    src={dollarSign}
                  />
                  ADD AUTOMATIC MONTHLY CONTRIBUTIONS
                </a>
              </div>
              <div
                className={`${providedProductType}-ineligible-button-background`}>
                <a
                  href={
                    providedProductType === MARYLAND_529_CLASS
                      ? maryland529Calculator
                      : national529Calculator
                  }
                  className="ineligible-button">
                  <img className="custom-video-button-image" src={planner} />
                  EXPLORE OUR COLLEGE SAVINGS CALCULATOR
                </a>
              </div>
              <div
                className={`${providedProductType}-ineligible-button-background`}>
                <a
                  href={transactions.collegeSavings.contribute}
                  className="ineligible-button">
                  <img className="custom-video-button-image" src={dollarSign} />
                  MAKE A CONTRIBUTION
                </a>
              </div>
            </div>
          </div>
          <AAMFooterContainer
            isMobileParam={isMobileApp}
            footerProductTypes={footerProductTypes}
            appLoaded={true}
          />
        </div>
      );
    }

    return (
      <div className="custom-video-page-container">
        <div className="custom-video-layout-container">
          <div className={`${providedProductType}-custom-video-header`}>
            <span className="header-title">
              Understanding Your Savings Just Got Easier
            </span>
          </div>
          <div className="title-text-container">
            <div className="active-beneficiary-text">
              Here&apos;s your personalized video for{' '}
              <span className={`${providedProductType}-beneficiary-name`}>
                {toUpper(activeBeneficiary)}
              </span>
            </div>
          </div>
          <div className="custom-video-page">
            <CustomVideo
              videoUrl={VIDEO_URL}
              productType={providedProductType}
              poster={placeholderImages[providedProductType]}
            />
          </div>
          {eligibleBeneficiaries.length > 0 && (
            <div className="eligible-beneficiaries-footer">
              Also see your video for:
              {eligibleBeneficiaries &&
                eligibleBeneficiaries.map((bene, i) => {
                  return (
                    <span key={i} className="beneficiary-button-container">
                      <button
                        className={`${providedProductType}-beneficiary-button`}
                        id={`${bene.firstName}-beneficiary-button`}
                        onClick={() => this.handleButtonClick(event, bene)}>
                        {toUpper(bene.firstName)}
                      </button>
                    </span>
                  );
                })}
            </div>
          )}
        </div>
        <AAMFooterContainer
          isMobileParam={isMobileApp}
          footerProductTypes={footerProductTypes}
          appLoaded={true}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  params: getQueryParams(state),
  view: getView(state),
  customVideo: getCustomVideoState(state),
  customer: getCustomer(state),
  isMobileApp: isMobile(state),
  videoEligibilities: getCustomVideoEligibility(state),
  requestStatus: getRequestStatus(state),
  customVideoEligibility: getHasCustomVideo(state),
  footerProductTypes: mapProductTypeToiiFooterBoolean(state)
});

export default withRouter(connect(mapStateToProps)(CustomVideoPage));
